import fpti from '../instrumentation';
import { fptiConstants, fptiEvents } from './fptiConstants';

/**
 * Track FPTI view event
 * @param {string} payerID - The payer ID
 */
export const trackViewEvent = (payerID) => {
  try {
    fpti.recordClick({
      payer_id: payerID,
      action: 'VIEW',
      page: 'third_party_permissions',
      event_name: fptiEvents.DEPRECATION_WARNING_VIEW,
      space_key: fptiConstants.SPACE_KEY,
      link: 'deprecation_warning_view',
    });
  } catch (error) {
    console.warn(fptiConstants.FPTI_ERROR_MESSAGE, error);
  }
};

/**
 * Track merchant segmentation
 * @param {string} payerID - The payer ID
 * @param {string} selectedOption - The selected merchant type option
 * @param {string} description - The description provided by the user
 */
export const trackMerchantSegmentation = (payerID, selectedOption, description) => {
  try {
    fpti.recordClick({
      payer_id: payerID,
      action: 'MERCHANT_SEGMENTATION',
      page: 'third_party_permissions',
      event_name: fptiEvents.MERCHANT_SEGMENTATION_RESPONSE,
      space_key: fptiConstants.SPACE_KEY,
      link: 'deprecation_warning_segmentation',
      merchant_type: selectedOption,
      free_text_response: description.substring(0, 100),
    });
  } catch (error) {
    console.warn(fptiConstants.FPTI_ERROR_MESSAGE, error);
  }
};

/**
 * Track continue click
 * @param {string} payerID - The payer ID
 * @param {string} selectedOption - The selected option
 * @param {string} description - The description provided by the user
 */
export const trackContinueClick = (payerID, selectedOption, description) => {
  try {
    fpti.recordClick({
      payer_id: payerID,
      action: 'CLICK_CONTINUE',
      page: 'third_party_permissions',
      event_name: fptiEvents.DEPRECATION_WARNING_CONTINUE,
      space_key: fptiConstants.SPACE_KEY,
      link: 'deprecation_warning_continue',
      selected_option: selectedOption,
      description: description.substring(0, 100),
    });
  } catch (error) {
    console.warn(fptiConstants.FPTI_ERROR_MESSAGE, error);
  }
};

/**
 * Track cancel/close
 * @param {string} payerID - The payer ID
 */
export const trackCancelClick = (payerID) => {
  try {
    fpti.recordClick({
      payer_id: payerID,
      action: 'CLICK_CANCEL',
      page: 'third_party_permissions',
      event_name: fptiEvents.DEPRECATION_WARNING_CANCEL,
      space_key: fptiConstants.SPACE_KEY,
      link: 'deprecation_warning_close',
    });
  } catch (error) {
        console.warn(fptiConstants.FPTI_ERROR_MESSAGE, error);
  }
};

/**
 * Track upgrade link click
 * @param {string} payerID - The payer ID
 * @param {string} upgradeUrl - The upgrade URL
 */
export const trackUpgradeLinkClick = (payerID, upgradeUrl) => {
  try {
    fpti.recordClick({
      payer_id: payerID,
      action: 'CLICK_UPGRADE_LINK',
      page: 'third_party_permissions',
      event_name: fptiEvents.DEPRECATION_WARNING_PPCP_LINK,
      space_key: fptiConstants.SPACE_KEY,
      link: upgradeUrl,
    });
  } catch (error) {
    // Silently ignore FPTI tracking errors
    console.warn(fptiConstants.FPTI_ERROR_MESSAGE, error);
  }
};
